import { useEffect, useState } from "react";
import "../../../assets/css/RackFrontView/rackFrontView.css";

const extractLevel = (location) => {
  const levelStr = location?.split(".").pop();
  const level = parseInt(levelStr, 10);
  return isNaN(level) ? null : level;
};

const isVerticalPallets = (data) =>
  data?.every(
    ({ rackType, row }) => rackType === "RACK_2" || row === data?.[0].row
  );

const RackFrontView = ({ locationData }) => {
  const [groupedByLevel, setGroupedByLevel] = useState({});
  const [vertical, setVertical] = useState(false);

  useEffect(() => {
    if (locationData) {
      const processed = locationData.map(
        ({
          location,
          locationType,
          palletPosition,
          row,
          lpn,
          sku,
          quantity,
        }) => ({
          location,
          locationType,
          palletPosition,
          row: locationType?.includes("Double Deep") ? palletPosition : row,
          lpn,
          sku,
          quantity,
          level: extractLevel(location),
        })
      );

      setVertical(isVerticalPallets(processed));

      const grouped = processed.reduce((acc, pallet) => {
        if (!acc[pallet.level]) acc[pallet.level] = [];
        acc[pallet.level].push(pallet);
        return acc;
      }, {});

      setGroupedByLevel(grouped);
    }
  }, [locationData]);

  return (
    <div className="pallet-card-container">
      {Object.entries(groupedByLevel)
        .sort((a, b) => b[0] - a[0])
        .map(([level, pallets]) => (
          <div key={level} className={vertical ? "flex-column" : ""}>
            <span className="level">Level {level}</span>
            <div className="pallet-row-front-view">
              {pallets.map((pallet, index) => (
                <PalletCard key={index} pallet={pallet} />
              ))}
            </div>
          </div>
        ))}
    </div>
  );
};

export default RackFrontView;

const PalletCard = ({ pallet: { lpn, sku, quantity, location, row } }) => {
  const details = [
    { label: "LPN", value: lpn },
    { label: "SKU", value: sku },
    { label: "Quantity", value: quantity },
  ];

  return (
    <div
      className={`${!lpn && !sku && !quantity ? "invisible " : ""}pallet-card`}
    >
      <p className="value">{location}</p>
      <span className="position">Position {row}</span>
      {details.map(({ label, value }, index) => (
        <div key={index} className="pallet-details-container">
          <p className="label">{label}</p>
          <p className="value">{value}</p>
        </div>
      ))}
    </div>
  );
};
